import { render, staticRenderFns } from "./PurchasesPage.vue?vue&type=template&id=5996f34a&"
import script from "./PurchasesPage.vue?vue&type=script&lang=js&"
export * from "./PurchasesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports